export function QuestionView({ q, value, onChange }) {
  return (
    <>
      <p className="text-[15px] leading-relaxed whitespace-pre-line mb-6 text-slate-800">{q.prompt}</p>

      {q.table && (
        <div className="border border-slate-300 mb-8 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-100 label-mono">
              <tr>{q.table.headers.map((h, i) => (
                <th key={i} className="text-left p-3 border-r last:border-r-0 border-slate-300">{h}</th>
              ))}</tr>
            </thead>
            <tbody>
              {q.table.rows.map((row, ri) => (
                <tr key={ri} className="border-t border-slate-300">
                  {row.map((cell, ci) => (
                    <td key={ci} className={`p-3 border-r last:border-r-0 border-slate-200 ${ci > 0 ? "font-mono-num" : "font-medium"}`}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {q.matrix && (
        <div className="mb-8 flex justify-center">
          <div className="grid grid-cols-3 border border-slate-400" style={{ width: 360 }}>
            {q.matrix.map((cell, i) => (
              <div key={i} className={`aspect-square border border-slate-300 ${cell ? "bg-white" : "bg-slate-50 flex items-center justify-center"}`}>
                {cell
                  ? <div className="w-full h-full p-2" dangerouslySetInnerHTML={{ __html: cell }} />
                  : <span className="text-3xl font-black text-[#002FA7]">?</span>}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className={q.matrix ? "grid grid-cols-2 md:grid-cols-4 gap-3" : "space-y-3"}>
        {Object.entries(q.options).map(([k, v]) => {
          const selected = value === k;
          const isSvg = typeof v === "string" && v.trim().startsWith("<svg");
          if (isSvg) {
            return (
              <label key={k} data-testid={`opt-${q.id}-${k}`}
                className={`border cursor-pointer transition-all p-3 flex flex-col items-center ${selected ? "border-[#002FA7] bg-[#002FA7]/5 shadow-hard" : "border-slate-200 hover:border-slate-400"}`}>
                <input type="radio" name={q.id} className="sr-only" checked={selected} onChange={() => onChange(k)} />
                <span className="label-mono text-[#002FA7] mb-2">{k}</span>
                <div className="w-20 h-20" dangerouslySetInnerHTML={{ __html: v }} />
              </label>
            );
          }
          return (
            <label key={k} data-testid={`opt-${q.id}-${k}`}
              className={`flex gap-4 p-4 border cursor-pointer transition-colors ${selected ? "border-[#002FA7] bg-[#002FA7]/5" : "border-slate-200 hover:border-slate-400"}`}>
              <input type="radio" name={q.id} className="mt-1 accent-[#002FA7]" checked={selected} onChange={() => onChange(k)} />
              <div><span className="label-mono mr-3 text-[#002FA7]">{k}</span><span>{v}</span></div>
            </label>
          );
        })}
      </div>
    </>
  );
}

export function ReviewCard({ d, index }) {
  const svgCorrect = typeof d.options[d.correct_answer] === "string" && d.options[d.correct_answer].startsWith("<svg");
  return (
    <div data-testid={`review-${index}`} className={`border p-6 bg-white ${d.is_correct ? "border-green-300" : "border-red-300"}`}>
      <div className="flex items-center gap-2 mb-3">
        <span className={`label-mono ${d.is_correct ? "text-green-600" : "text-red-600"}`}>{index + 1}. {d.is_correct ? "Corretto" : "Sbagliato"}</span>
      </div>
      <p className="whitespace-pre-line text-sm mb-3 text-slate-700">{d.prompt}</p>
      {d.table && (
        <div className="border border-slate-300 mb-3 overflow-x-auto text-xs">
          <table className="w-full">
            <thead className="bg-slate-100 label-mono"><tr>{d.table.headers.map((h, j) => (<th key={j} className="text-left p-2 border-r last:border-r-0 border-slate-300">{h}</th>))}</tr></thead>
            <tbody>{d.table.rows.map((row, ri) => (<tr key={ri} className="border-t border-slate-300">{row.map((cell, ci) => (<td key={ci} className="p-2 border-r last:border-r-0 border-slate-200 font-mono-num">{cell}</td>))}</tr>))}</tbody>
          </table>
        </div>
      )}
      {d.matrix && (
        <div className="mb-3 grid grid-cols-3 border border-slate-400" style={{ width: 210 }}>
          {d.matrix.map((cell, j) => (
            <div key={j} className={`aspect-square border border-slate-300 ${cell ? "bg-white" : "bg-slate-50 flex items-center justify-center"}`}>
              {cell ? <div className="w-full h-full p-1" dangerouslySetInnerHTML={{ __html: cell }} /> : <span className="text-xl font-black text-[#002FA7]">?</span>}
            </div>
          ))}
        </div>
      )}
      <div className="text-sm space-y-1">
        <div>La tua risposta: <span className="font-mono-num font-bold">{d.your_answer || "—"}</span></div>
        <div>Risposta corretta: <span className="font-mono-num font-bold text-[#002FA7]">{d.correct_answer}</span>
          {!svgCorrect && <span className="ml-2">— {d.options[d.correct_answer]}</span>}
        </div>
        {svgCorrect && <div className="flex gap-2 items-center mt-2"><span className="label-mono text-xs text-slate-500">Corretta:</span><div className="w-14 h-14 border border-[#002FA7]" dangerouslySetInnerHTML={{ __html: d.options[d.correct_answer] }} /></div>}
      </div>
      {d.explanation && <div className="mt-4 pt-4 border-t border-slate-200 text-sm text-slate-600"><span className="label-mono text-slate-400">Spiegazione: </span>{d.explanation}</div>}
    </div>
  );
}
